<template>
  <div class="template-wrapper">
    <h2 class="page-title">{{ $t('productList') }}</h2>
    <el-divider></el-divider>
    <el-button @click="dialogVisible = true" v-if="product_setting_edit === '1'">{{ $t('addProduct') }}</el-button>

    <template v-if="product_setting_read === '1'">
      <br />
      <br />
      <el-form ref="storeform" :model="storeform">
        <el-form-item :label="$t('selectStore')">
          <template>
            <div class="" style="display: flex">
              <el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
                <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                <el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
                  :value="item.storeid"></el-option>
              </el-select>
            </div>
          </template>
        </el-form-item>
      </el-form>
    </template>

    <template v-if="product_setting_read === '1'">
      <el-table :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        " stripe style="width: 100%" @sort-change="sortChange">

        <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
        </el-table-column>
        <el-table-column prop="goods_name" :label="$t('productName')" sortable="custom">
        </el-table-column>
        <el-table-column prop="product_retailer_id" :label="$t('contentid')" sortable="custom">
        </el-table-column>
        <el-table-column prop="goods_price" :label="$t('price')" sortable="custom">
        </el-table-column>
        <el-table-column prop="isCoupon" :label="$t('isCoupon')" sortable="custom">
          <template slot-scope="scope">
            <div v-if="scope.row.isCoupon == '1'">{{ $t('yes') }}</div>
            <div v-if="scope.row.isCoupon == '0'">{{ $t('no') }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('productqrcode')" align="center" width="180">
            <template slot-scope="scope">
                <div class="operationVid">
                    <el-button @click="ewm(scope.row.storeid, scope.row.catalog_id, scope.row.product_retailer_id)">{{
                        $t("productqrcode")
                    }}</el-button>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('adminset')" align="center">
          <template slot-scope="scope">
            <div class="operationVid">
              <el-button @click="edititem(scope.row)" v-if="product_setting_edit === '1'">{{ $t('edit') }}</el-button>
              <el-button @click="delitem(scope.row.id)" v-if="product_setting_edit === '1'">{{ $t('delete') }}</el-button>
              <span v-if="product_setting_edit === '0'">{{ $t("NoPermissions") }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t('total') }} {{ tableData.length }} {{ $t('items') }}</span>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="prev,pager,next" :total="tableData.length"></el-pagination>
      </div>
    </template>
    <template v-if="product_setting_read === '0'">
        <span>{{ $t("NoPermissions") }}</span>
    </template>


    <!-- add -->
    <el-dialog :title="$t('addProduct')" :visible.sync="dialogVisible" :width="$store.state.isMobile ? '90%' : '556px'"
      :before-close="handleClose">
      <div class="add-template">
        <el-form ref="form" :model="form">
          <el-form-item :label="$t('storeList')">
            <el-select v-model="form.storeid" placeholder="">
              <el-option v-for="item in storelist" :label="item.name" :value="item.storeid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('productName')">
            <el-input v-model="form.goods_name" rows="1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('contentid')">
            <el-input v-model="form.product_retailer_id" rows="1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('price')">
            <el-input v-model="form.goods_price" rows="1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('catalogid')">
            <el-input v-model="form.catalog_id" rows="1"></el-input>
          </el-form-item>

          <el-form-item :label="$t('isCoupon')">
            <el-select v-model="form.isCoupon" :placeholder="$t('pleaseSelect')">
              <el-option :label="$t('no')" value="0">
              </el-option>
              <el-option :label="$t('yes')" value="1">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('coupon')">
            <el-select v-model="form.huodong_yhq_id" placeholder="">
              <el-option :label="$t('none')" value="0"></el-option>
              <el-option v-for="item in huodonglist" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="sure">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- edit -->
    <el-dialog :title="$t('editProduct')" :visible.sync="dialogEditFormVisible"
      :width="$store.state.isMobile ? '90%' : '556px'" :before-close="handleClose">
      <div class="add-template">
        <el-form ref="editform" :model="editform">
          <el-form-item :label="$t('productName')">
            <el-input v-model="editform.goods_name" rows="1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('contentid')">
            <el-input v-model="editform.product_retailer_id" rows="1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('price')">
            <el-input v-model="editform.goods_price" rows="1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('catalogid')">
            <el-input v-model="editform.catalog_id" rows="1"></el-input>
          </el-form-item>

          <el-form-item :label="$t('isCoupon')">
            <el-select v-model="editform.isCoupon" :placeholder="$t('pleaseSelect')">
              <el-option :label="$t('no')" value="0">
              </el-option>
              <el-option :label="$t('yes')" value="1">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('coupon')">
            <el-select v-model="editform.huodong_yhq_id" placeholder="">
              <el-option :label="$t('none')" value="0"></el-option>
              <el-option v-for="item in huodonglist" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEditFormVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="edit">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('qrcode')" :visible.sync="dialogVisible_ewm" width="400px" :before-close="handleClose">
			<div class="add-template">
                <p>{{ $t("ProductURL") }}</p>
                <p>{{ qrUrl }}</p>
                <div class="qr-container">
                    <img v-if="qrDataUrl" :src="qrDataUrl" alt="QR Code">
                </div>
			</div>
		</el-dialog>


  </div>
</template>
<script>
import { formatDate } from '../../assets/date.js'
import { tongyong, getShopProduct, addShopProduct, getShopProductQR, getStore } from '@/api'
import QRCode from 'qrcode'
export default {
  data() {
    return {
      product_setting_read: '0',
    product_setting_edit: '0',
    exportcsv: '0',
      qyid: '',
      storeid: '',
      show: false,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      dialogVisible: false,
      dialogEditFormVisible: false,
      dialogVisible_ewm: false,
      tableData: [

      ],
      storelist: [],
      form: {
        qyid: "",
        goods_name: "",
        product_retailer_id: "",
        goods_price: "",
        catalog_id: "",
        isCoupon: "",
        huodong_yhq_id: "",
        action: ""
      },
      editform: {
        id: "",
        qyid: "",
        goods_name: "",
        product_retailer_id: "",
        goods_price: "",
        catalog_id: "",
        isCoupon: "",
        huodong_yhq_id: "",
        action: ""
      },
      huodonglist: [],
      storeform: {
        storeid: ''
      },
      qrContent: 'https://example.com',
      qrDataUrl: '',
      qrUrl: ''
    };
  },
  filters: {
    formatDate: function (time) {
      time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  created() {
    var user = JSON.parse(window.localStorage.getItem("userinfo"));
    //console.log(user)
    //this.qyid = user.id
    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		this.qyid = auser.qyid
        this.storeid = auser.storeid
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
		this.product_setting_read = auser.product_setting_read
		this.product_setting_edit = auser.product_setting_edit
		this.exportcsv = auser.exportcsv
    this.getlist(auser.storeid);
    this.gethuodonglist()
    this.getstorelist()
  },

  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible_ewm = false;
      this.dialogEditFormVisible = false;
    },
    changeTableStoreid() {
      console.log('storeid:' + this.storeform.storeid)
      this.getlist(this.storeform.storeid)
    },
    getlist(storeid) {
      this.show = true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));



      let fdata = {
        //qyid: user.id,
        qyid: this.qyid,
        storeid: storeid
      };
      getShopProduct(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.tableData = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.show = false
      });




    },
    getstorelist() {
      console.log('go taocan');
      var user = JSON.parse(window.localStorage.getItem('userinfo'))

      let fdata = {
        qyid: this.qyid,
        storeid: this.storeid
      };
      getStore(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.storelist = res.data
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    gethuodonglist() {
      console.log('go taocan');
      var user = JSON.parse(window.localStorage.getItem('userinfo'))
      console.log("user")
      console.log(user)

      let fdata = {
        sjk: 'messenger_huodong_yhq',
        action: 'list',

        //qyid: user.id,
        qyid: this.qyid,
        //storeid: storeform.storeid
      }
      tongyong(fdata).then(res => {
        if (res.code == 1) {
          console.log(res);
          this.huodonglist = res.data
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    sure() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user)

      if (!this.form.goods_name) {
        this.$message.error($t('pleaseEnterProductName'));
        return
      }
      if (!this.form.product_retailer_id) {
        this.$message.error($t('pleaseEnterContentid'));
        return
      }
      if (!this.form.goods_price) {
        this.$message.error($t('pleaseEnterPrice'));
        return
      }
      if (this.form.goods_price < 1) {
        this.$message.error($t('minPriceIs1'));
        return
      }
      if (!this.form.catalog_id) {
        this.$message.error($t('pleaseEnterCatalogId'));
        return
      }
      if (!this.form.isCoupon) {
        this.$message.error($t('pleaseSelectIsCoupon'));
        return
      }

      //this.form.qyid = user.id
      this.form.qyid = this.qyid
      this.form.action = "add"


      addShopProduct(this.form).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogVisible = false;
          this.getlist();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    edit() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user)

      if (!this.editform.goods_name) {
        this.$message.error($t('pleaseEnterProductName'));
        return
      }
      if (!this.editform.product_retailer_id) {
        this.$message.error($t('pleaseEnterContentid'));
        return
      }
      if (!this.editform.goods_price) {
        this.$message.error($t('pleaseEnterPrice'));
        return
      }
      if (this.editform.goods_price < 1) {
        this.$message.error($t('minPriceIs1'));
        return
      }
      if (!this.editform.catalog_id) {
        this.$message.error($t('pleaseEnterCatalogId'));
        return
      }
      if (!this.editform.isCoupon) {
        this.$message.error($t('pleaseSelectIsCoupon'));
        return
      }

      //this.editform.qyid = user.id
      this.editform.qyid = this.qyid
      this.editform.action = "edit"


      addShopProduct(this.editform).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogEditFormVisible = false;
          this.getlist();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    edititem(data) {
      this.editform = data
      this.dialogEditFormVisible = true
      console.log("data")
      console.log(data)
    },
    delitem(id) {
      this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

        console.log('del..');
        var user = JSON.parse(window.localStorage.getItem("userinfo"));
        let deletedata = {
          action: 'delete',
          id: id,
          //qyid: user.id
          qyid: this.qyid
        }
        addShopProduct(deletedata).then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.dialogEditFormVisible = false;
            this.getlist();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      }).catch(_ => {



      })


    },
    sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop, order));
    },
    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    },
    ewm(storeid, catalog_id, product_retailer_id) {

        let fdata = {
            //qyid: user.id,
            qyid: this.qyid,
            storeid: storeid,
            catalogid: catalog_id,
            retailerid:product_retailer_id
        };
        console.log(fdata)
        var qrurl = "";
        getShopProductQR(fdata).then((res) => {
            if (res.code == 1) {
                qrurl = res.data
                this.genQR(qrurl)
            } 
            else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        });
        /*
        console.log(qrurl)
	    this.dialogVisible_ewm = true
        try {
            this.qrDataUrl = await QRCode.toDataURL(qrurl, {
            width: 360,
            margin: 2,
            color: {
                dark: '#000000',
                light: '#ffffff'
            }
            })
        } catch (err) {
            console.error('QR generation failed:', err)
        }*/
	},
    async genQR(qrurl) {


        this.dialogVisible_ewm = true
        this.qrUrl = qrurl
        try {
            this.qrDataUrl = await QRCode.toDataURL(qrurl, {
            width: 360,
            margin: 2,
            color: {
                dark: '#000000',
                light: '#ffffff'
            },
            errorCorrectionLevel: 'M'
            })
        } catch (err) {
            console.error('QR generation failed:', err)
        }

        /*
        QRCode.toCanvas(document.getElementById('canvas'), qrurl, function (error) {
            if (error) console.error(error)
            console.log('success!');
        })*/
    },

  }



};
</script>
<style lang="scss" scoped>
.el-pagination__total {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  box-sizing: border-box;
}

.pendingList-wrapper {}

.pagination {
  width: 100%;
  margin: 30px auto;
}

.qr-container img {
  max-width: 400px;
  margin-top: 20px;
}

::v-deep .el-select {
  width: 100%;
}
</style>